"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconInQueue = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconInQueue = function SvgIconInQueue(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1C2.22386 1 2 1.22386 2 1.5V10.5C2 10.7761 2.22386 11 2.5 11H2.7C2.97614 11 3.2 10.7761 3.2 10.5V1.5C3.2 1.22386 2.97614 1 2.7 1H2.5ZM4.40002 1.5C4.40002 1.22386 4.62388 1 4.90002 1H5.10002C5.37617 1 5.60002 1.22386 5.60002 1.5V10.5C5.60002 10.7761 5.37617 11 5.10002 11H4.90002C4.62388 11 4.40002 10.7761 4.40002 10.5V1.5ZM9.18898 6.00001L8.05002 4.15878L8.05002 7.84124L9.18898 6.00001ZM10.4373 6.26305C10.537 6.10186 10.537 5.89816 10.4373 5.73697L7.77524 1.43352C7.51033 1.00528 6.85002 1.19301 6.85002 1.69656V10.3035C6.85002 10.807 7.51033 10.9947 7.77524 10.5665L10.4373 6.26305Z",
    fill: "currentColor"
  }));
};

exports.SvgIconInQueue = SvgIconInQueue;